/**
 * @name setModal.js
 */
import Splide from '@splidejs/splide';

class setModal {
    constructor() {
        this.html = document.querySelector('html');
        this.toggleBtn = document.querySelectorAll('[data-modal-id]');
        this.closeBtn = document.querySelectorAll('.close-button');

        // スライダー
        this.splide = null;
        this.slider = document.querySelector('.p-job-modal__slider.splide');
        this.sliderItems = null;

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.__event();
    }

    /**
     * @name __event
     */
    __event() {
        this.toggleBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
                // e.preventDefault();
                const target = e.currentTarget.getAttribute('data-modal-id');
                this.__open();
                this.__initSlider(target);
            });
        });

        this.__close();
    }

    __open() {
        this.html.dataset.state = 'modalOpen';
    }

    /**
     * @name __close
     */
    __close() {

        let close = () => {
            this.html.dataset.state = '';
            setTimeout(() => {
                this.splide.destroy();
            }, 500);
        }

        this.closeBtn.forEach(btn => {
            btn.addEventListener('click', () => {
                close();
            });
        });

        //escキーで閉じる
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                close();
            }
        });
    }

    /**
     * @name __initSlider
     */
    __initSlider(target) {
        this.sliderItems = this.slider.querySelectorAll('.modal-item.splide__slide');
        let activeItem = this.slider.querySelector(`[data-modal="${target}"][data-active="true"]`);
        let activeIndex = Array.from(this.sliderItems).indexOf(activeItem);

        let options = {
            type: 'loop',
            gap: '2rem',
            pagination: false,
        };

        this.splide = new Splide(this.slider, options).mount();

        if (activeIndex !== -1) {
            this.splide.go(activeIndex);
        }
    }
}

export default setModal;